import React, { createContext, useContext, useState } from 'react';

const UserContext = createContext(null);

export function UserProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('gw_user')) || null; } catch { return null; }
  });

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('gw_user', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('gw_user');
  };

  const updateUser = (userData) => {
    setUser(userData);
    localStorage.setItem('gw_user', JSON.stringify(userData));
  };

  return (
    <UserContext.Provider value={{ user, login, logout, updateUser }}>
      {children}
    </UserContext.Provider>
  );
}

export const useUser = () => useContext(UserContext);
